export default __webpack_public_path__ + "static/hdmi_xr_adapter_m-1bb646b5d32d03369782af5e0472d172.png";